import { render } from "./AddContact.vue?vue&type=template&id=cc34da1a&scoped=true"
import script from "./AddContact.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddContact.vue?vue&type=script&charset=utf-8&lang=js"

import "./AddContact.vue?vue&type=style&index=0&id=cc34da1a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc34da1a"]])

export default __exports__